import { render, staticRenderFns } from "./follow _sign.vue?vue&type=template&id=2ac3c394&scoped=true"
import script from "./follow _sign.vue?vue&type=script&lang=js"
export * from "./follow _sign.vue?vue&type=script&lang=js"
import style0 from "./follow _sign.vue?vue&type=style&index=0&id=2ac3c394&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac3c394",
  null
  
)

export default component.exports